// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

// The license fee an order carries, priced on the client exactly as the server prices it at checkout
// (aw-server src/utils/licenseFee_util.js orderLicenseFee, AUT-6569 D2): a cents-rounded percentage of the price
// before the fee and tax. 'added' puts it on the total; 'prepaid' records the amount the prepaid license covered,
// outside the total; 'none' records nothing. The two sides share one table of test vectors.

export const LICENSE_FEE_PERCENT = 10;

export interface ILicenseFeeInput {
  mode?: string | null;
  percent?: number;
  baseDollar?: number | null;
}

const roundToCents = (value: number) => Math.round(value * 100) / 100;

export const licenseFeeFor = ({ mode, percent = LICENSE_FEE_PERCENT, baseDollar }: ILicenseFeeInput) => {
  const priced = typeof baseDollar === 'number' && Number.isFinite(baseDollar) && baseDollar > 0;
  const carriesFee = mode === 'added' || mode === 'prepaid';
  const licenseFeeDollar = carriesFee && priced ? roundToCents((baseDollar as number) * (percent / 100)) : 0;
  return { licenseFeeDollar, addedDollar: mode === 'added' ? licenseFeeDollar : 0 };
};

// The sidebar / PDF row label: "License fee (10%)" when added, "License fee — prepaid (annual)" when prepaid, none otherwise
export const licenseFeeRowLabel = (mode?: string | null, percent?: number, prepaidCadence?: string | null) => {
  if (mode === 'added') return `License fee (${percent ?? LICENSE_FEE_PERCENT}%)`;
  if (mode === 'prepaid') return `License fee — prepaid${prepaidCadence ? ` (${prepaidCadence})` : ''}`;
  return null;
};

// The Order History CSV's "License Fee Status" word; blank for an order that predates the record
export const licenseFeeStatusLabel = (mode?: string | null) => {
  if (mode === 'added') return 'Added';
  if (mode === 'prepaid') return 'Prepaid';
  if (mode === 'none') return 'None';
  return '';
};
